import React from "react";
import { Link } from "react-router-dom";

interface MyHrPublicLayoutLinkProps {
  label: React.ReactNode;
  path: string;
}

export const MyHrPublicLayoutLink = ({
  label,
  path,
}: MyHrPublicLayoutLinkProps) => {
  return (
    <Link
      id="forgot-password-button"
      to={path}
      style={{
        textDecoration: "none",
        fontSize: 16,
        letterSpacing: 0.44,
        color: "#CC0033",
      }}
    >
      {label}
    </Link>
  );
};

export default MyHrPublicLayoutLink;
